/**
 * Read the chat id out of a chat route's ``router.query.id``.
 *
 * Both chat routes are optional catch-alls, so the value is normally a
 * ``string[]``. The string branch stays as a guard: reading ``[0]`` off a string
 * silently returns its first character.
 */
export function routeChatIdFromQuery(raw: string | string[] | undefined): string | null {
  if (Array.isArray(raw)) return raw[0] ?? null;
  if (typeof raw === 'string') return raw;
  return null;
}
